import React from "react";
import { Col, Row } from "react-bootstrap";

const GridShimmer = ({ 
  rows = 6, 
  gridColumns = { lg: 3, md: 4, sm: 6, xs: 12 } 
}) => {
  return (
    <div className="card-grid-container shimmer-grid">
      <Row>
        {[...Array(rows)].map((_, index) => (
          <Col
            key={index}
            lg={gridColumns.lg}
            md={gridColumns.md}
            sm={gridColumns.sm}
            xs={gridColumns.xs}
          >
            <div className="grid-card shimmer-card">
              {/* Card Header */}
              <div className="card-header">
                <div className="shimmer shimmer_title" />
                <div className="shimmer shimmer_image" />
              </div>

              {/* Card Body */}
              <div className="card-body">
                <div className="stats-grid">
                  <div className="stat-item">
                    <div className="shimmer shimmer_text" />
                    <div className="shimmer shimmer_value" />
                  </div>
                  <div className="stat-item">
                    <div className="shimmer shimmer_text" />
                    <div className="shimmer shimmer_value" />
                  </div>
                  <div className="stat-item">
                    <div className="shimmer shimmer_text" />
                    <div className="shimmer shimmer_value" />
                  </div>
                </div>
              </div>

              {/* Card Footer */}
              <div className="card-footer">
                <div className="grid-actions">
                  <div className="left-icons">
                    <div className="shimmer shimmer_icon" />
                    <div className="shimmer shimmer_icon" />
                    <div className="shimmer shimmer_icon" />
                  </div>
                  <div className="shimmer shimmer_toggle" />
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default GridShimmer;